import { GENERAL_SET_TERMS_AND_CONDITION } from '../action/getTermsAndCondition';

const initialState = {};

export default function termsAndConditionReducer(state = initialState, action) {
  switch (action.type) {
    case GENERAL_SET_TERMS_AND_CONDITION:
      return action.payload;
    default:
      return state;
  }
}
